<template>
    <div>
        <div class="container text-center">
            <div class="row">
                <div class="col-sm">
                    <h2>Rotating IPs</h2>
                    <p>New IP
                        <b>every requests</b>. Or sticky IP every
                        <b>1 min</b>,
                        <b>10 min</b>,
                        <b>30 min</b>
                    </p>
                </div>
                <div class="col-sm">
                    <h2>Authorization</h2>
                    <p>Support
                        <b>Username/Password</b> login. Or
                        <b>IP</b> Authorization</p>
                </div>
            </div>

            <div class="row">
                <div class="col-sm">
                    <h2>Regions</h2>
                    <p>All features are available in over 150 countries</p>
                    <p>
                        <span v-for="country in countries"
                              :key="country"
                              :class="'flag-icon flag-icon-' + country" />
                    </p>
                </div>
            </div>
        </div>

        <hr>

        <div class="card-deck plans">
            <div v-for="plan in plans"
                 :key="plan.id"
                 class="card plan text-center">
                <div :class="{ 'bg-danger': plan.status.hot, 'bg-dark': !plan.status.hot }"
                     class="card-header text-white">
                    {{ plan.name }}
                </div>
                <div class="card-body">
                    <h4 class="card-title">${{ plan.price/100 }}</h4>
                    <p class="card-text text-muted">
                        <small>per {{ plan.interval }}</small>
                    </p>
                </div>
                <ul class="list-group list-group-flush">
                    <li class="list-group-item">
                        <b>Unlimited</b><br>Residential Proxies*</li>
                    <li class="list-group-item">
                        <b>{{ prettyBytes(plan.quota) }}</b><br>Bandwidth Limit</li>
                    <li class="list-group-item">
                        <b>${{ plan.additional_price/100 }}</b><br>Each additional 1 GB</li>
                </ul>
                <div class="card-body">
                    <router-link v-if="!plan.status.soon"
                                 :to="/checkout/ + plan.id"
                                 :class="{ 'btn-danger': plan.status.hot, 'btn-dark': !plan.status.hot }"
                                 class="btn text-white"
                                 role="button">Sign up</router-link>

                    <a v-if="plan.status.soon"
                       class="btn disabled"
                       role="button">Sold Out Currently</a>
                </div>
            </div>
        </div>

        <div class="alert alert-light text-center"
             role="alert">
            ALL SALE FINAL - NO REFUNDS
        </div>
        <div class="alert alert-light text-center"
             role="alert">
            *Refer only to IP address in pool that are accessible , not guaranteed to give you 1 million or infinite number of IP address that is beyond normal use
        </div>
    </div>
</template>

<script>
import 'flag-icon-css/css/flag-icon.min.css'
import prettyBytes from 'pretty-bytes'

import { config, proxy, handler, aw } from 'website-core'

export default {
    data() {
        return {
            // cached plans
            plans: proxy.plans,
            // plans: [],

            countries: proxy.countries.map(country =>
                country.code.toLowerCase()
            ),
        }
    },
    async created() {
        // real plans
        await this.getPlans()
    },
    methods: {
        prettyBytes(quota) {
            return prettyBytes(quota)
        },
        async getPlans() {
            try {
                const plans = await aw.plan.get()
                this.plans = plans
            } catch (err) {
                handler(err)
            }
        },
    },
}
</script>

<style scoped>
.plans {
    margin: 2rem 0;
}
.plan {
    margin: 0.5rem;
}
</style>
